import { UpdatePage } from '@components/molecules';
import { SwitchElement, TextFieldElement, useForm } from 'react-hook-form-mui';
import API from '@apps/nnc/services/machine';
import { ModelProps } from '@/types';
import { MachineSchema, MachineSchemaType } from '@apps/nnc/schemas/machine';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import UnitAPI from '@apps/localization/services/unit';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';
import ProductionPhaseAPI from '@apps/nnc/services/productionphase';

export default function ObjectUpdatePage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const formContext = useForm<MachineSchemaType>({
    resolver: zodResolver(MachineSchema),
    defaultValues: {
      is_active: true,
    },
  });
  const getUnitDivisions = async () => {
    try {
      const unitId = formContext.getValues('unit')?.id;
      const response = await UnitAPI.getUnitDivisions(unitId);
      return response;
    } catch (error) {
      console.error('Error fetching unit divisions:', error);
      return [];
    }
  };
  return (
    <UpdatePage
      schema={MachineSchema}
      api={API}
      title={t('Machine')}
      modelProps={modelProps}
      formcontext={formContext}
      customPath="nnc/machine"
      canSaveAndContinue
      keepValues={['unit', 'division']}
    >
      <Grid size={{ xs: 12, md: 6 }}>
        <TextFieldElement name="name" label={t('Name')} fullWidth required />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AsyncAutocompleteElement
          name="unit"
          label={t('Unit')}
          api={() =>
            UnitAPI.select({
              is_active: 1,
            })
          }
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AsyncAutocompleteElement
          api={getUnitDivisions}
          name="division"
          label={t('Identified Area')}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AsyncAutocompleteElement
          api={() =>
            ProductionPhaseAPI.select({
              is_active: 1,
              unit: formContext.getValues('unit')?.id,
              division: formContext.getValues('division')?.id,
            })
          }
          name="production_phase"
          label={t('Production Phase')}
          fetchOnMount
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <SwitchElement label={t('Is Active?')} name="is_active" />
      </Grid>
    </UpdatePage>
  );
}
